import { render, staticRenderFns } from "./LightCourseResultPage.vue?vue&type=template&id=0218175e&scoped=true&"
import script from "./LightCourseResultPage.vue?vue&type=script&lang=js&"
export * from "./LightCourseResultPage.vue?vue&type=script&lang=js&"
import style0 from "./LightCourseResultPage.vue?vue&type=style&index=0&id=0218175e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0218175e",
  null
  
)

export default component.exports